import React from "react";
import Aside from "./Aside";
import Section from "./Section";
import { Container, Row } from "react-bootstrap";

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sideBar: "expanded",
      // window.innerWidth > 1200 || window.innerWidth < 768
      // ? "expanded"
      // : "collapsed",
    };
  }

  handleCallback = (childData) => {
    this.setState({
      sideBar: childData,
    });
  };

  render() {
    return (
      <main className={`body ${this.state.sideBar}`}>
        <Container className="full-width">
          <Row>
            <div className="main-left-col">
              <Aside parentCallback={this.handleCallback} />
            </div>
            <div className="main-right-col">
              <Section />
            </div>
          </Row>
        </Container>
      </main>
    );
  }
}

export default Main;
